import { useQuery } from "@tanstack/react-query";
import UserMedal from "../interfaces/userMedal";
import { USER_MEDALS_URL } from "../util/constants";
import useApi from "./useApi";

const useLastUserMedal = (username: any) => {
    const { recover } = useApi<UserMedal[]>(`${USER_MEDALS_URL}/${username}/last`);

    return useQuery({
        queryKey: ["userMedal", username],
        queryFn: () => recover()
    });
};

export default useLastUserMedal;